module.exports = __webpack_public_path__ + "static/media/jeux-saphir.09348f2b.png";